import httpService from 'src/services/app/http.service'
import { storageService } from 'src/services/app/storage.service'
import { log } from 'src/services/app/log.service'
import { FCM_ENDPOINTS, STORAGE_KEYS } from 'src/services/consts/api.const'

const TOKEN_CACHE_TTL = 1000 * 60 * 60 * 24 * 7 // 7 days

const subscribeToTopic = async (token, topic, user) => {
  if (!user) return
  return httpService.post(FCM_ENDPOINTS.SUBSCRIBE_TO_TOPIC, {
    fcm_token: token,
    topic,
    user_full_name: user.displayName,
  })
}

const unsubscribeFromTopic = async (token, topic, user) => {
  if (!user) return
  return httpService.post(FCM_ENDPOINTS.UNSUBSCRIBE_FROM_TOPIC, {
    fcm_token: token,
    topic,
    user_full_name: user.displayName,
  })
}

const unsubscribeFromAllTopics = async (token) => {
  return httpService.post(FCM_ENDPOINTS.UNSUBSCRIBE_FROM_ALL_TOPICS, {
    fcm_token: token,
  })
}

const updateToken = async (token) => {
  const cached = storageService.getCachedData(STORAGE_KEYS.FCM_TOKEN_CACHE)
  if (cached === token) {
    log.info('[FCM] Token unchanged, skipping backend update')
    return { cached: true, token }
  }

  const response = await httpService.post(FCM_ENDPOINTS.UPDATE_TOKEN, { token })
  storageService.cacheData(STORAGE_KEYS.FCM_TOKEN_CACHE, token, TOKEN_CACHE_TTL)
  log.info('[FCM] Token sent to backend and cached')
  return response
}

const clearTokenCache = () => {
  storageService.remove(STORAGE_KEYS.FCM_TOKEN_CACHE)
  log.info('[FCM] Token cache cleared')
}

export {
  subscribeToTopic,
  unsubscribeFromTopic,
  unsubscribeFromAllTopics,
  updateToken,
  clearTokenCache,
}
